// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.affiliate-layout {
    display: flex;
    min-height: 100vh;
  }
  
  .main-wrapper {
    flex: 1 1;
    margin-left: 240px;
    transition: margin-left 0.3s ease;
  }
  
  .sidebar-collapsed .main-wrapper {
    margin-left: 78px;
  }
  
  .sidebar-hidden .main-wrapper {
    margin-left: 0;
  }
  
  .main-content {
    padding: 20px;
    min-height: calc(100vh - 120px); /* Account for header and footer */
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .main-wrapper {
      margin-left: 0;
    }
    
    .affiliate-layout {
      position: relative;
    }
  }`, "",{"version":3,"sources":["webpack://./src/affilate-app/pages/_layout/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,+BAA+B,EAAE,kCAAkC;EACrE;;EAEA,eAAe;EACf;IACE;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".affiliate-layout {\r\n    display: flex;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  .main-wrapper {\r\n    flex: 1;\r\n    margin-left: 240px;\r\n    transition: margin-left 0.3s ease;\r\n  }\r\n  \r\n  .sidebar-collapsed .main-wrapper {\r\n    margin-left: 78px;\r\n  }\r\n  \r\n  .sidebar-hidden .main-wrapper {\r\n    margin-left: 0;\r\n  }\r\n  \r\n  .main-content {\r\n    padding: 20px;\r\n    min-height: calc(100vh - 120px); /* Account for header and footer */\r\n  }\r\n  \r\n  /* Responsive */\r\n  @media (max-width: 768px) {\r\n    .main-wrapper {\r\n      margin-left: 0;\r\n    }\r\n    \r\n    .affiliate-layout {\r\n      position: relative;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
